<template>
  <v-app id="daisukeApp">
    <nuxt />
    <snackbar />
  </v-app>
</template>

<script>
import Snackbar from "@/components/Snackbar";

export default {
  middleware: ["auth"],
  components: { Snackbar },
};
</script>

<style lang="scss">
#daisukeApp {
  .daisuke-main-bar .v-toolbar__content {
    padding: 0 16px 0 0;
  }
  .bordered-bar {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  .v-input.v-input--is-disabled input,
  .v-select,
  .v-label {
    color: #00000099;
  }
  .v-select__selection--disabled {
    color: #2c2c2c;
  }
  .v-text-field--outlined.v-input--is-disabled fieldset {
    border-color: #0000000d;
  }
  .v-badge__badge .v-icon {
    color: inherit;
    font-size: 12px;
    margin: 0 -2px;
  }
}
</style>
